// Production: same-origin `/api` (Vercel rewrites to Railway). Ignore VITE_API_URL so a
// leftover Railway URL in Vercel env cannot put the browser back on a cross-origin path.
// Dev: Vite proxies `/api` → localhost:5001, or VITE_API_URL if set.
export const API_BASE_URL = import.meta.env.DEV
  ? (import.meta.env.VITE_API_URL || 'https://harvesthelp-production.up.railway.app')
  : '';

// Debug: Log environment variables (uncomment for debugging)
// console.log('🔍 Environment check:');
// console.log('🔍 VITE_API_URL:', import.meta.env.VITE_API_URL);
// console.log('🔍 Final API_BASE_URL:', API_BASE_URL);

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
  },
  USERS: {
    PROFILE: '/api/profile',
  },
  FOOD_BANKS: {
    LIST: '/api/food-banks',
  },
  DONATIONS: {
    LIST: '/api/donations',
    CREATE: '/api/donations',
  },
  PICKUPS: {
    LIST: '/api/pickups',
    CREATE: '/api/pickups',
  },
} as const; 